module.exports = __webpack_public_path__ + "static/media/Icon03.dd864244.png";